import Vue from "vue";
import VueRouter from "vue-router";
import routes from "@/router/routes";
import i18n from "@/modules/i18n";

// import { IconUserSquare } from "@lde/core_lde_vue";
import { UilFileAlt } from "@iconscout/vue-unicons";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    ...routes,
    {
      path: "/p/:pays",
      name: "home_pays",
      component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue"),
    },
    {
      path: "/e/:code",
      name: "home_code",
      component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue"),
    },
    {
      path: "/erreur-paiement",
      name: "erreur-paiement",
      component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue"),
      meta: { commande: true, statut: -2 },
    },
    {
      path: "/paiement-refuse",
      name: "paiement-refuse",
      component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue"),
      meta: { commande: true, statut: -1 },
    },
    {
      path: "/commande-annulee",
      name: "commande-annulee",
      component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue"),
      meta: { commande: true, statut: 0 },
    },
    {
      path: "/commande-validee",
      name: "commande-validee",
      component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue"),
      meta: { commande: true, statut: 1 },
    },
    {
      path: "/commande-transmise",
      name: "commande-transmise",
      component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue"),
      meta: { commande: true, statut: 2 },
    },
    // {
    //   path: "/listes/",
    //   name: "listes",
    //   component: () => import(/* webpackChunkName: "listes" */ "@/views/Listes.vue"),
    //   meta: {
    //     title: i18n.t("listes.titre"),
    //     icon: UilFileAlt,
    //   },
    // },
    {
      path: "/liste/:id",
      name: "liste",
      component: () => import(/* webpackChunkName: "liste" */ "@/views/Liste.vue"),
      meta: {
        title: i18n.t("liste.titre"),
        icon: UilFileAlt,
      },
    },
    {
      path: "/panier",
      name: "panier",
      component: () => import(/* webpackChunkName: "Panier" */ "@/views/Panier.vue"),
      meta: {
        title: i18n.t("panier.mon-panier"),
        // icon: IconPanier,
      },
    },
  //   {
  //     path: "/403",
  //     name: "403",
  //     component: () => import(/* webpackChunkName: "403" */ "@/views/Forbidden.vue"),
  //   },
    {
      path: "*",
      name: "404",
      component: () => import(/* webpackChunkName: "404" */ "@/views/NotFound.vue"),
    },
  ],
});

export default router;
